exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Checkbox {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.Checkbox > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Checkbox label {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: center;\r\n\t    align-items: center;\r\n}\r\n\r\n.Checkbox label {\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.Checkbox label:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n.Checkbox i, .Checkbox svg {\r\n\topacity: 0.5;\r\n}\r\n\r\n.Checkbox.Checked i, .Checkbox.Checked svg {\r\n\topacity: 1;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Checkbox/Checkbox.css
// module id = 681
// module chunks = 0